import { PageContext, uuid } from '@zto/zpage-runtime'
import { SysConfigPaths } from '@/config'
import { getTdlNumber } from '@/utils'

export function unitDictDialog(isEdit: boolean) {
  return {
    width: 420,
    labelWidth: 110,
    itemSpan: 24,
    title: isEdit ? '编辑单元' : '添加单元',
    formItems: [
      {
        type: 'input',
        prop: 'name',
        label: '单元名称',
        required: true,
        trim: true,
        maxlength: 10
      },
      {
        type: 'input',
        prop: 'tdlNumber',
        label: '单元通信码',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`, // 编辑时 显示
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        }
      },
    ],

    onShow: async ({ app, data }: PageContext) => {
      if(!isEdit) {
        return {
          payload: {
            name: undefined,
            tdlNumber: undefined
          }
        }
      }
      return {
        payload: {
          ...data,
          tdlNumber: data?.data?.tdlNumber || undefined
        }
      }
    },
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      const { tdlNumber, name, ...other} = data || {}
      if(!isEdit){
        return {
          parentNodePath: SysConfigPaths.UNIT_DICT,
          code: uuid(),
          name,
          // sort: 1,
          status: 1, // 1:启用 0:禁用
          data: {
            tdlNumber: getTdlNumber(name)
          }
        }
      }
      return {
        ...other,
        name,
        data: {
          tdlNumber
        }
      }
    },
    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
